export default __webpack_public_path__ + "static/media/guidethumb.9028eeb8.png";